import { Checkbox, debounce, Link } from '@mui/material';
import { differenceInMinutes } from 'date-fns';
import { FC, useCallback, useEffect, useMemo, useState } from 'react';
import { FiCreditCard, FiX } from 'react-icons/fi';
import {
  IoIosArrowDropleftCircle,
  IoIosArrowDroprightCircle,
  IoIosArrowForward,
  IoIosCheckmarkCircle,
  IoIosInformationCircleOutline,
} from 'react-icons/io';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import { Loading } from '../../components/Loading';
import PrivacyPolicyArticle from '../../components/PrivacyPolicyArticle';
import { StyledButton } from '../../components/StyledButton';
import { StyledCardInformationCar } from '../../components/StyledCardInformationsCar';
import { StyledInput } from '../../components/StyledInput';
import { StatusModalConfirmClick } from '../../components/StyledModalConfirmClick';
import { StyledTitle } from '../../components/StyledTitle';
import Terms from '../../components/Terms';
import { IDebt, usePayment } from '../../context/Payments';
import { useUser } from '../../context/UserContext';
import { findConsultById } from '../../hooks/usePayments';
import router from '../../routes';
import { contatoCommunix } from '../../services/contatoCommunix';
import { encrypt } from '../../services/crypto';
import theme from '../../styles/themes/default';
import { emailValidation } from '../../utils/EmailValidation';
import { encryptCard } from '../../utils/encrypt';
import { MONTHS, PATH_CREDIT_CARD, TYPE_DOCUMENT, UF } from '../../utils/enums';
import formatCep from '../../utils/formatCep';
import { formatDocument } from '../../utils/formatDocument';
import formatMobilePhoneNumber from '../../utils/formatMobilePhoneNumber';
import { handleSearchCep } from '../../utils/handleSearchCep';
import { ufsNamed } from '../../utils/ufsNamed';
import { validateCpf } from '../../utils/validateCpf';
import { validateCreditCard } from '../../utils/validateCreditCard';
import { validateSecurityCode } from '../../utils/validateSecurityCode';
import { IOption, StyledSelect } from '../UserVehicles/components/StyledSelect';
import {
  CreditPaymentDiv,
  DefaultContainer,
  DefaultContainerSummary,
  DefaultRowForm,
  DefaultTextLinkSummary,
  DefaultTextModal,
  DefaultTextSummary,
  DivDefaultModal,
  DivModalPrivacyButton,
  DivModalPrivacyContent,
  DivModalTermsContent,
  LinkLabelSummary,
  ModalButton,
  ModalContent,
  ModalContentTitle,
  ModalCredit,
  ModalDetail,
  ModalDetailContainer,
  ModalDetailContainerDebt,
  PaymentSummaryContainer,
  RowCepForm,
  TextCep,
  TitleSummary,
} from './style';

declare global {
  interface Window {
    Konduto: any;
    __kdt: any;
  }
}

const CreditPayment: FC = () => {
  const {
    installments,
    ipvaSelected,
    licenciamentoSelected,
    dpvatSelected,
    multasSelected,
    outrosSelected,
    handleSelectInstallment,
    cupom,
    consultCode,
    vehicle,
    // owner,
    pix,
    // isPix,
    // cupomStatus,
    handleSetCupom,
    // renavam
  } = usePayment();

  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [showPolicyModal, setShowPolicyModal] = useState(false);
  const [showTermsModal, setShowTermsModal] = useState(false);
  const [modalDetail, setShowModalDetail] = useState(false);

  const { isLoggedIn, user } = useUser();
  const navigate = useNavigate();

  const [installmentsOpts, setInstallmentsOpts] = useState<IOption[]>([]);
  const [installmentOpt, setInstallmentOpt] = useState<IOption>();

  const [loading, setLoading] = useState(false);
  const [cardFlag, setCardFlag] = useState('N/A');
  const [clientIdFromPartner, setClientIdFromPartner] = useState<
    string | undefined
  >(undefined);
  const [cardNumber, setCardNumber] = useState('');
  const [nameCard, setNameCard] = useState<string>('');
  const [cpf, setCpf] = useState<string>('');
  const [expirationDate, setExpirationDate] = useState<string>('');
  const [year, setYear] = useState<string>('');
  const [securityCode, setSecurityCode] = useState<string>('');
  const [email, setEmail] = useState<string>('');
  const [telephone, setTelephone] = useState<string>('');

  const [cep, setCep] = useState<string>('');
  const [address, setAdress] = useState<string>('');
  const [number, setNumber] = useState<string>('');
  const [adjunct, setAdjunct] = useState<string>('');
  const [neighborhood, setNeighborhood] = useState<string>('');
  const [state, setState] = useState<IOption>();
  const [city, setCity] = useState<string>('');
  const [cupomLocal, setCupomLocal] = useState('');

  const [validating, setValidating] = useState(false);
  const [privacyChecked, setPrivacyChecked] = useState(false);
  const [cpfChecked, setCpfChecked] = useState(false);

  const [arrayActionsConfirmModal] = useState<Array<() => void>>([]);

  const cpfError = useMemo(() => {
    const result = validateCpf({
      cpf,
      emptyCpf: 'Preenchimento obrigatório',
      incorrectCpf: 'CPF inválido',
    });
    return result.message;
  }, [cpf]);

  const creditCardError = useMemo(() => {
    const result = validateCreditCard({
      creditCard: cardNumber,
      emptyCreditCard: 'Preenchimento obrigatório',
      incorrectCreditCard: 'Preenchimento incorreto',
      unauthorizedCreditCard:
        'Cartão não permitido. Inserir um cartão autorizado!',
      clientIdFromPartner: clientIdFromPartner,
    });
    return result.message;
  }, [cardNumber]);

  const requiredField = (value: any) => {
    return value ? '' : 'Preenchimento obrigatório';
  };

  const years = useMemo(() => {
    const newYears = [];
    const actualYear = new Date().getFullYear();
    for (let index = 0; index < 14; index++) {
      const element = {
        id: String(actualYear + index),
        value: String(actualYear + index),
      };
      newYears.push(element);
    }
    return newYears;
  }, []);

  const handleCardNumber = useCallback((cardNumberForm: string) => {
    const cardNumberHandling = cardNumberForm.replace(/[^0-9]+/g, '');

    const cards = {
      visa: /^4[0-9]{12}(?:[0-9]{3})/,
      mastercard:
        /^((5(([1-2]|[4-5])[0-9]{8}|0((1|6)([0-9]{7}))|3(0(4((0|[2-9])[0-9]{5})|([0-3]|[5-9])[0-9]{6})|[1-9][0-9]{7})))|((508116)\\d{4,10})|((502121)\\d{4,10})|((589916)\\d{4,10})|(2[0-9]{15})|(67[0-9]{14})|(506387)\\d{4,10})/,
      diners: /^3(?:0[0-5]|[68][0-9])[0-9]{11}/,
      amex: /^3[47][0-9]{13}/,
      hipercard: /^(606282\d{10}(\d{3})?)|(3841\d{15})/,
      elo: /^4011(78|79)|^43(1274|8935)|^45(1416|7393|763(1|2))|^50(4175|6699|67[0-6][0-9]|677[0-8]|9[0-8][0-9]{2}|99[0-8][0-9]|999[0-9])|^627780|^63(6297|6368|6369)|^65(0(0(3([1-3]|[5-9])|4([0-9])|5[0-1])|4(0[5-9]|[1-3][0-9]|8[5-9]|9[0-9])|5([0-2][0-9]|3[0-8]|4[1-9]|[5-8][0-9]|9[0-8])|7(0[0-9]|1[0-8]|2[0-7])|9(0[1-9]|[1-6][0-9]|7[0-8]))|16(5[2-9]|[6-7][0-9])|50(0[0-9]|1[0-9]|2[1-9]|[3-4][0-9]|5[0-8]))/,
    };

    let flag = 'N/A';

    Object.entries(cards).forEach((card) => {
      if (card[1].test(cardNumberHandling)) {
        flag = card[0];
      }
    });

    return flag;
  }, []);

  useEffect(() => {
    const cardFlagResult = handleCardNumber(cardNumber);
    setCardFlag(cardFlagResult);
  }, [cardNumber, handleCardNumber]);

  useEffect(() => {
    const installmentOpts = installments?.map((installment) => ({
      id: `${installment.month}x de ${new Intl.NumberFormat('pt-BR', {
        currency: 'BRL',
        style: 'currency',
      }).format(Number(installment.installmentPrice))}`,
      value: installment.totalPrice,
    }));
    let installmentOptDefault: IOption = {
      id: '',
      value: '',
    };
    console.log(installments);
    installments?.forEach((installment) => {
      if (!installment.checked) {
        return installmentOptDefault;
      } else {
        return (installmentOptDefault = {
          id: `${installment.month}x de ${new Intl.NumberFormat('pt-BR', {
            currency: 'BRL',
            style: 'currency',
          }).format(Number(installment.installmentPrice))}`,
          value: installment.totalPrice,
        });
      }
    });
    setInstallmentOpt(installmentOptDefault);
    setInstallmentsOpts(installmentOpts);
  }, [installments]);

  const securityCodeError = useMemo(() => {
    const result = validateSecurityCode({
      cardFlag: cardFlag,
      value: securityCode,
    });
    return result.message;
  }, [securityCode]);

  const emailError = useMemo(() => {
    const result = emailValidation({
      email,
      emptyEmail: 'Campo obrigatório',
      incorrectEmail: 'Email inválido',
    });
    return result.message;
  }, [email]);

  useEffect(() => {
    const parceiro = 'true'; //router.query?.parceiro;
    const clientId = '352'; //router.query?.clientId;

    // const returnRoute = ''//router.query.previousRoute;

    if (parceiro === 'true') {
      setClientIdFromPartner(clientId as string);
      //   setPartnerModal(true);
    } else {
      if (!isLoggedIn) {
        // router.push(
        //   `/${
        //     returnRoute === '/selecao-debitos'
        //       ? 'consulta-debitos'
        //       : returnRoute || '/'
        //   }`
        // );
        return;
      }
    }
  }, [isLoggedIn, router /* user?.attributes*/]);

  useEffect(() => {
    if (cupom) {
      setCupomLocal(cupom);
    }
  }, [cupom]);

  const debouncedSave = debounce((nextValue) => handleSetCupom(nextValue), 600);

  const handleCupomInput = useCallback(
    (e: React.FormEvent<HTMLInputElement>) => {
      const regex = /[⁰¹²³⁴⁵⁶⁷⁸⁹ºª]/g;
      const value = e.currentTarget.value.replace(regex, '');

      setCupomLocal(value);
    },
    [debouncedSave],
  );

  const handleCep = async (cep: string) => {
    if (cep.length === 8) {
      try {
        setLoading(true);
        const result = await handleSearchCep(cep);
        if (result.erro) {
          Swal.fire({
            icon: 'error',
            title: 'Erro!',
            html: 'Não foi possivel encontrar o cep informado. Verifique e tente novamente!',
            confirmButtonColor: theme.colors.orange.primary,
          });
        }
        console.log(result);

        const state =
          ufsNamed.find(({ id }) => result.uf && id === result.uf)?.id || '';

        console.log('state', state);
        handleSetStateViaCep(state);
        setNumber(result.complemento);
        setCity(result.localidade);
        setNeighborhood(result.bairro);
        setAdress(result.logradouro);
      } catch (error) {
      } finally {
        setLoading(false);
      }
    }
    setCep(formatCep(cep));
  };

  const handleSetInstallments = useCallback(
    (e: any) => {
      const installment = installments.find((i) => i.totalPrice === e);
      if (installment) {
        handleSelectInstallment(installment);
      }
      setInstallmentOpt(e ? e : ({} as IOption));
    },
    [installments, handleSelectInstallment],
  );

  const handleSetState = useCallback((e: any) => {
    const opt = Object.keys(UF).map((key) => ({
      id: key,
      value: UF[key as keyof typeof UF],
    }));
    const state = opt.find((i) => i.value === e);
    setState(state ? state : ({} as IOption));
  }, []);

  const handleSetStateViaCep = (uf: string) => {
    const opt = Object.keys(UF).map((key) => ({
      id: key,
      value: UF[key as keyof typeof UF],
    }));
    const state = opt.find((i) => i.id === uf);
    setState(state ? state : ({} as IOption));
  };

  const handleFormValidate = useCallback(() => {
    const validations = [
      requiredField(cardNumber),
      requiredField(nameCard),
      requiredField(cpf),
      requiredField(expirationDate),
      requiredField(expirationDate),
      requiredField(year),
      requiredField(securityCode),
      requiredField(installmentOpt),
      requiredField(email),
      requiredField(telephone),
      requiredField(city),
      requiredField(state),
      requiredField(neighborhood),
      requiredField(number),
      requiredField(address),
      requiredField(cep),
      emailError,
      securityCodeError,
      creditCardError,
      cpfError,
    ];
    return !validations.some((v) => v);
  }, [
    cardNumber,
    nameCard,
    cpf,
    expirationDate,
    expirationDate,
    year,
    securityCode,
    installmentOpt,
    email,
    telephone,
    city,
    state,
    neighborhood,
    number,
    address,
    cep,
  ]);

  const konduto = useCallback(() => {
    const period = 300;
    const limit = 20 * 1e3;
    let nTry = 0;
    const intervalID = setInterval(function () {
      let clear = limit / period <= ++nTry;

      if (
        typeof window.Konduto !== 'undefined' &&
        typeof window.Konduto.setCustomerID !== 'undefined'
      ) {
        window.Konduto.setCustomerID(String(cpf));
        clear = true;
      }
      if (clear) {
        clearInterval(intervalID);
      }
    }, period);
  }, [cpf]);

  const labelToValue = (parcel: string): string => {
    const indexR = parcel.toUpperCase().indexOf('R');
    if (indexR !== -1) {
      return parcel.slice(indexR);
    }
    return '';
  };

  const labelToParams = (parcel: string): string => {
    const indexR = parcel.toUpperCase().indexOf('R');
    if (indexR !== -1) {
      const params = parcel.slice(0, indexR).trim();
      return params;
    }
    return '';
  };

  function handleMoneyValues(value: string | number) {
    return `R$ ${(value || 0)?.toLocaleString('pt-BR', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })}`;
  }

  const handlePayment = async () => {
    // e.preventDefault();
    setShowConfirmModal(false);
    setLoading(true);
    setValidating(true);
    if (!handleFormValidate()) {
      Swal.fire({
        icon: 'error',
        title: 'Campos inválidos!',
        html: `Alguns campos ainda estão inválidos. Corrija-os e tente novamente.`,
        confirmButtonColor: theme.colors.orange.primary,
      });
      setLoading(false);
      return;
    }

    if (!privacyChecked) {
      Swal.fire({
        icon: 'error',
        title: 'Campos inválidos!',
        html: `Necessário aceitar política de privacidade`,
        confirmButtonColor: theme.colors.orange.primary,
      });
      setLoading(false);
      return;
    }

    if (!cpfChecked) {
      Swal.fire({
        icon: 'error',
        title: 'Campos inválidos!',
        html: `Necessário aceitar uso do cpf para efetivação do pagamento`,
        confirmButtonColor: theme.colors.orange.primary,
      });
      setLoading(false);
      return;
    }

    try {
      const encrypted = encryptCard({
        cardNumber: cardNumber.replace(/\D/g, ''),
        month: expirationDate.length > 1 ? expirationDate : '0' + expirationDate,
        year: year,
        codSec: securityCode,
      });

      const debitos: { codigo: number; valor: number }[] = [];

      if (ipvaSelected.length) {
        ipvaSelected.map((i: IDebt) => {
          const debito = {
            codigo: i.codigo,
            valor: i.valor,
          };
          debitos.push(debito);
        });
      }

      if (licenciamentoSelected.length) {
        licenciamentoSelected.map((i: IDebt) => {
          const debito = {
            codigo: i.codigo,
            valor: i.valor,
          };
          debitos.push(debito);
        });
      }

      if (dpvatSelected.length) {
        dpvatSelected.map((i: IDebt) => {
          const debito = {
            codigo: i.codigo,
            valor: i.valor,
          };
          debitos.push(debito);
        });
      }

      if (multasSelected.length) {
        multasSelected.map((i: IDebt) => {
          const debito = {
            codigo: i.codigo,
            valor: i.valor,
          };
          debitos.push(debito);
        });
      }

      if (outrosSelected.length) {
        outrosSelected.map((i: IDebt) => {
          const debito = {
            codigo: i.codigo,
            valor: i.valor,
          };
          debitos.push(debito);
        });
      }

      const data = {
        encrypted,
        nameCard,
        cpf,
        cep,
        address,
        number,
        adjunct,
        neighborhood,
        uf: state?.value && "",
        city: city,
        email,
        telephone,
        cupomLocal,
        installment: installments.find((i) => i.checked),
        consultCode,
        sub: user?.sub,
        debitos,
        // mercadoPago: deviceId
      };

      const dataEncrypted = encrypt(data);

      let storageConsult: any;

      const checkContato = window.localStorage.getItem(
        `Zignet:Contato:${consultCode}`,
      );
      console.log(
        '🚀 ~ file: index.tsx ~ line 809 ~ handleSubmit ~ checkContato',
        checkContato,
      );

      if (checkContato !== 'true') {
        await contatoCommunix({
          consulta: String(consultCode),
          telefone: user?.phone || '',
          // cnpj: user?.cnpj || '',
          cnpj: '64032287000114',
          email: user?.email || '',
          nome: user?.name || '',
        }).then((response) =>
          window.localStorage.setItem(
            `Zignet:Contato:${consultCode}`,
            response.sucesso,
          ),
        );
      }

      if (vehicle.placa !== undefined) {
        storageConsult = await findConsultById(consultCode);

        if (
          storageConsult.payloadCaptura &&
          storageConsult.status !== 'NEGADO'
        ) {
          setShowConfirmModal(false);
          setLoading(false);

          window.localStorage.setItem(
            'zignet:PayloadCaptura',
            JSON.stringify(storageConsult.payloadCaptura),
          );
          window.localStorage.setItem(
            'zignet:PayloadComprovante',
            JSON.stringify(storageConsult.payloadComprovante),
          );
          Swal.fire({
            icon: 'warning',
            html: `Já existe um pagamento em andamento para este veículo;`,
            confirmButtonColor: theme.colors.orange.primary,
          }).then((result) => {
            if (result.isConfirmed) {
              navigate('/proof');
            }
          });

          return;
        }

        // const checkConsultDuration =
        //     differenceInMinutes(new Date(), new Date(storageConsult.created_at)) -
        //     180;

        // if (checkConsultDuration >= 30) {
        //     Swal.fire({
        //         icon: 'error',
        //         title: 'Atenção!',
        //         html: `Tempo de operação expirado. Por favor realize uma nova consulta para efetuar o pagamento`,
        //         confirmButtonColor: theme.colors.orange.primary,
        //     });
        //     setShowConfirmModal(false);
        //     setLoading(false);
        //     return;
        // }
      } else {
        const consultTimeStamp = JSON.parse(
          window.localStorage.getItem('@zignet:ConsultTimeStamp')!,
        );

        const diffMinutes = differenceInMinutes(
          new Date(),
          new Date(consultTimeStamp),
        );

        if (diffMinutes >= 30) {
          Swal.fire({
            icon: 'error',
            title: 'Atenção!',
            html: `Tempo de operação expirado. Por favor realize uma nova consulta para efetuar o pagamento`,
            confirmButtonColor: theme.colors.orange.primary,
          });
          setShowConfirmModal(false);
          setLoading(false);
          return;
        }
      }

      // const payment = await creditCardPayment(dataEncrypted);
      let payment: any;

      console.log('🚀 ~ file: index.tsx:886 ~ handleSubmit ~ payment', payment);

      if (payment?.warning) {
        Swal.fire({
          icon: 'warning',
          title: 'Atenção!',
          html: `Valor divergente do Débito.`,
          confirmButtonColor: theme.colors.orange.primary,
        });
        setShowConfirmModal(false);
        setLoading(false);
        return;
      }

      if (payment?.paymentLimit) {
        Swal.fire({
          icon: 'warning',
          title: 'Atenção!',
          html: `Não foi possível seguir com seu pagamento. Por gentileza, entre em contato com nossa Equipe de Atendimento`,
          confirmButtonColor: theme.colors.orange.primary,
        });
        setShowConfirmModal(false);
        setLoading(false);
        return;
      }

      const { codigoPagamento, mensagem, sucesso, urlRecibo, autorizacao } =
        payment;

      if (sucesso) {
        konduto();

        // try {
        //     const eventData = {
        //         event: 'pagamento_debitos',
        //         transaction_id: consultCode,
        //         value: installmentOpt?.value,
        //         coupon: cupom,
        //         pagament: 'Cartão',
        //         dataUser: [
        //             {
        //                 email: user?.attributes?.email,
        //                 nome: user?.attributes?.name
        //             }
        //         ],
        //         items: [
        //             ...dpvatSelected.map((dpvat) => ({
        //                 item_category: 'DPVAT',
        //                 vencimento: dpvat?.vencimento,
        //                 item_name: dpvat?.descricao,
        //                 price: dpvat?.valor,
        //                 currence: 'BRL'
        //             })),
        //             ...ipvaSelected.map((ipva) => ({
        //                 item_category: 'IPVA',
        //                 vencimento: ipva?.vencimento,
        //                 item_name: ipva?.descricao,
        //                 price: ipva?.valor,
        //                 currence: 'BRL'
        //             })),
        //             ...licenciamentoSelected.map((licenciamento) => ({
        //                 item_category: 'Licenciamento',
        //                 vencimento: licenciamento?.vencimento,
        //                 item_name: licenciamento?.descricao,
        //                 price: licenciamento?.valor,
        //                 currence: 'BRL'
        //             })),
        //             ...multasSelected.map((multa) => ({
        //                 item_category: 'Multa',
        //                 vencimento: multa?.vencimento,
        //                 item_name: multa?.descricao,
        //                 price: multa?.valor,
        //                 currence: 'BRL'
        //             })),
        //             ...outrosSelected.map((outro) => ({
        //                 item_category: outro?.descricao,
        //                 vencimento: outro?.vencimento,
        //                 item_name: outro?.descricao,
        //                 price: outro?.valor,
        //                 currence: 'BRL'
        //             }))
        //         ]
        //     };
        //     console.log('🚀 ~ file: index.tsx:528 ~ handleSubmit ~ eventData:', eventData);
        //     // window.dataLayer.push(eventData);
        // } catch (error) {
        //     console.log('Datalayer:', error);
        // }

        // router.push({
        //     pathname: '/comprovante',
        //     query: {
        //         codigoPagamento,
        //         urlRecibo,
        //         autorizacao,
        //         clientId: router.query?.clientId
        //     }
        // });
      } else {
        Swal.fire({
          icon: 'warning',
          title: 'Atenção!',
          html:
            mensagem ||
            `Erro ao efetuar pagamento da consulta ${consultCode}, tente novamente`,
          confirmButtonColor: theme.colors.orange.primary,
        });
        return;
      }

      Swal.fire({
        icon: 'success',
        title: 'Sucesso!',
        html: `Pagamento realizado com sucesso`,
        confirmButtonColor: theme.colors.orange.primary,
      }).then((result) => {
        if (result.isConfirmed) {
          navigate('/proof', {
            state: {
              codigoPagamento,
              urlRecibo,
              autorizacao,
              clientId: 123, //TODO: PERGUNTAR SOBRE O clientID
            },
          });
        }
      });
    } catch (error: any) {
      console.log('pagamento-debitos: ', error?.response?.status ?? error?.message);
      const msg = error?.response?.data?.message
        ? `Erro interno ao efetuar pagamento da consulta ${consultCode}: ${error?.response?.data?.message}`
        : undefined;
      Swal.fire({
        icon: 'warning',
        title: 'Atenção!',
        html:
          msg ||
          `Erro interno ao efetuar pagamento da consulta ${consultCode}, tente novamente`,
        confirmButtonColor: theme.colors.orange.primary,
      });
    } finally {
      setShowConfirmModal(false);
      setLoading(false);
    }
  };

  function maskDigits(input: string) {
    const length = input.length;

    return input
      .split('')
      .map((char, index) => {
        if (/\d/.test(char) && index < length - 4) {
          return '*';
        }
        return char;
      })
      .join('');
  }

  return (
    <>
      <DefaultContainer>
        {loading && <Loading position="fixed" />}
        {showConfirmModal && (
          <StatusModalConfirmClick
            type={'info'}
            text={
              <div style={{ display: 'grid' }}>
                <DefaultTextModal weight={600}>
                  Você está finalizando o pagamento de débito do seguinte
                  veículo:
                </DefaultTextModal>
                {/* <div
                  style={{
                    marginTop: '16px',
                    display: 'flex',
                    justifyContent: 'center',
                  }}
                >
                  <DefaultTextModal weight={600}>
                    Proprietário{' '}
                    <span style={{ color: 'rgba(66, 66, 66, 1)' }}>
                      CELILIA VITAL D
                    </span>
                  </DefaultTextModal>
                </div> */}
                <div
                  style={{
                    marginTop: '16px',
                    display: 'flex',
                    justifyContent: 'center',
                  }}
                >
                  <DefaultTextModal weight={600}>
                    Placa{' '}
                    <span style={{ color: 'rgba(66, 66, 66, 1)' }}>
                      {vehicle.placa}
                    </span>
                  </DefaultTextModal>
                </div>
                <div
                  style={{
                    marginTop: '16px',
                    display: 'flex',
                    justifyContent: 'center',
                  }}
                >
                  <DefaultTextModal weight={600}>
                    Detran{' '}
                    <span style={{ color: 'rgba(66, 66, 66, 1)' }}>{vehicle.uf}</span>
                  </DefaultTextModal>
                </div>
                {(vehicle.renavam && vehicle.renavam.length > 0) && <div
                  style={{
                    marginTop: '16px',
                    display: 'flex',
                    justifyContent: 'center',
                  }}
                >
                  <DefaultTextModal weight={600}>
                    Renavam{' '}
                    <span style={{ color: 'rgba(66, 66, 66, 1)' }}>
                      {maskDigits(vehicle.renavam ?? "")}
                    </span>
                  </DefaultTextModal>
                </div>}
              </div>
            }
            differentColor={false}
            titleButtonOne="Fechar"
            titleButtonTwo="Pagar"
            newAction={handlePayment}
            setModal={setShowConfirmModal}
            callActions={arrayActionsConfirmModal}
            paddingButton={20}
            iconClose={true}
            classNameButtons="buttonsPayment"
            twoButtons={true}
          />
        )}
        {showPolicyModal && (
          <DivDefaultModal>
            <DivModalPrivacyContent>
              <PrivacyPolicyArticle title={'Política de privacidade'} />
              <DivModalPrivacyButton>
                <button
                  onClick={() => {
                    setShowPolicyModal(false);
                  }}
                >
                  Fechar
                  <FiX />
                </button>
              </DivModalPrivacyButton>
            </DivModalPrivacyContent>
          </DivDefaultModal>
        )}
        {showTermsModal && (
          <DivDefaultModal>
            <DivModalPrivacyContent>
              <DivModalTermsContent>
                <Terms />
              </DivModalTermsContent>
              <DivModalPrivacyButton>
                <button
                  onClick={() => {
                    setShowTermsModal(false);
                  }}
                >
                  Fechar
                  <FiX />
                </button>
              </DivModalPrivacyButton>
            </DivModalPrivacyContent>
          </DivDefaultModal>
        )}
        {modalDetail && (
          <ModalCredit>
            <ModalContent>
              <ModalContentTitle>Detalhes do pedido</ModalContentTitle>
              <ModalDetail>
                {ipvaSelected?.length > 0 && (
                  <ModalDetailContainer>
                    <h2>IPVA</h2>
                    {ipvaSelected?.map((ipva) => (
                      <ModalDetailContainerDebt>
                        <p>
                          {ipva.descricao} - {ipva.descricaoAdicional}
                        </p>
                        <p>
                          {new Intl.NumberFormat('pt-BR', {
                            style: 'currency',
                            currency: 'BRL',
                          }).format(ipva.valor)}
                        </p>
                      </ModalDetailContainerDebt>
                    ))}
                  </ModalDetailContainer>
                )}
                {dpvatSelected?.length > 0 && (
                  <ModalDetailContainer>
                    <h2>DPVAT</h2>
                    {dpvatSelected?.map((dpvat) => (
                      <ModalDetailContainerDebt>
                        <p>
                          {dpvat.descricao} - {dpvat.descricaoAdicional}
                        </p>
                        <p>
                          {new Intl.NumberFormat('pt-BR', {
                            style: 'currency',
                            currency: 'BRL',
                          }).format(dpvat.valor)}
                        </p>
                      </ModalDetailContainerDebt>
                    ))}
                  </ModalDetailContainer>
                )}
                {multasSelected?.length > 0 && (
                  <ModalDetailContainer>
                    <h2>Multas</h2>
                    {multasSelected?.map((multa) => (
                      <ModalDetailContainerDebt>
                        <p>
                          {multa.descricao} - {multa.descricaoAdicional}
                        </p>
                        <p>
                          {new Intl.NumberFormat('pt-BR', {
                            style: 'currency',
                            currency: 'BRL',
                          }).format(multa.valor)}
                        </p>
                      </ModalDetailContainerDebt>
                    ))}
                  </ModalDetailContainer>
                )}
                {licenciamentoSelected?.length > 0 && (
                  <ModalDetailContainer>
                    <h2>Licenciamento</h2>
                    {licenciamentoSelected?.map((licenciamento) => (
                      <ModalDetailContainerDebt>
                        <p>
                          {licenciamento.descricao} -{' '}
                          {licenciamento.descricaoAdicional}
                        </p>
                        <p>
                          {new Intl.NumberFormat('pt-BR', {
                            style: 'currency',
                            currency: 'BRL',
                          }).format(licenciamento.valor)}
                        </p>
                      </ModalDetailContainerDebt>
                    ))}
                  </ModalDetailContainer>
                )}
                {outrosSelected?.length > 0 && (
                  <ModalDetailContainer>
                    <h2>Outros</h2>
                    {outrosSelected?.map((outro) => (
                      <ModalDetailContainerDebt>
                        <p>
                          {outro.descricao} - {'outro.descricaoAdicional'}
                        </p>
                        <p>
                          {new Intl.NumberFormat('pt-BR', {
                            style: 'currency',
                            currency: 'BRL',
                          }).format(outro.valor)}
                        </p>
                      </ModalDetailContainerDebt>
                    ))}
                  </ModalDetailContainer>
                )}
                <ModalButton>
                  <button
                    onClick={() => {
                      setShowModalDetail(false);
                    }}
                  >
                    Fechar
                    <FiX />
                  </button>
                </ModalButton>
              </ModalDetail>
            </ModalContent>
          </ModalCredit>
        )}
        <CreditPaymentDiv>
          <StyledTitle marginTop={3.4} title=" Informações do veículo" />
          <StyledCardInformationCar
            plate={vehicle.placa}
            uf={vehicle.uf}
            year={vehicle.ano?.toString()}
            brand={vehicle.marca}
          />
          <StyledTitle marginTop={4.5} title=" Pagamento" />
          <DefaultRowForm>
            <StyledInput
              haveMargin={true}
              type="text"
              name="number-card"
              placeholder="Número do cartão"
              value={cardNumber}
              onChange={(e) =>
                setCardNumber(
                  formatDocument(e.target.value, TYPE_DOCUMENT.CREDITCARD),
                )
              }
              maxLength={16}
              error={validating && !!creditCardError}
              errorMessage={creditCardError}
              isCreditCard={cardFlag === 'N/A' ? false : true}
              icon={
                cardFlag !== 'N/A' ? (
                  <img
                    src={
                      cardFlag === 'visa'
                        ? PATH_CREDIT_CARD.VISA
                        : cardFlag === 'mastercard'
                          ? PATH_CREDIT_CARD.MASTERCARD
                          : cardFlag === 'diners'
                            ? PATH_CREDIT_CARD.DINERS
                            : cardFlag === 'amex'
                              ? PATH_CREDIT_CARD.AMEX
                              : cardFlag === 'hipercard'
                                ? PATH_CREDIT_CARD.HIPERCARD
                                : PATH_CREDIT_CARD.ELO
                    }
                    width={40}
                    height={40}
                    alt="Card flag"
                  />
                ) : (
                  <FiCreditCard />
                )
              }
            />
            <StyledInput
              haveMargin={true}
              type="text"
              name="name-card"
              placeholder="Nome impresso no cartão"
              value={nameCard}
              onChange={(e) => setNameCard(e.target.value)}
              error={validating && !!requiredField(nameCard)}
              errorMessage={requiredField(nameCard)}
            />
            <StyledInput
              haveMargin={true}
              type="text"
              name="cpf"
              placeholder="CPF do titular"
              value={cpf}
              onChange={(e) =>
                setCpf(formatDocument(e.target.value, TYPE_DOCUMENT.CPF))
              }
              maxLength={14}
              error={validating && !!cpfError}
              errorMessage={cpfError}
            />
          </DefaultRowForm>
          <DefaultRowForm>
            <StyledSelect
              value={expirationDate}
              setValue={setExpirationDate}
              options={Object.keys(MONTHS).map((key) => ({
                id: key,
                value: MONTHS[key as keyof typeof MONTHS],
              }))}
              error={validating && !!requiredField(expirationDate)}
              errorMessage={requiredField(expirationDate)}
              name="valididy-month"
              placeholder="Mês de validade"
              haveMargin={true}
              style={{ width: '96%' }}
            />
            <StyledSelect
              name="year"
              placeholder="Ano"
              haveMargin={true}
              value={year}
              setValue={setYear}
              options={years}
              error={validating && !!requiredField(year)}
              errorMessage={requiredField(year)}
              style={{ width: '96%' }}
            />
            <StyledInput
              haveMargin={true}
              type="text"
              name="security-code"
              placeholder="Cód. de segurança"
              value={securityCode}
              onChange={(e) => setSecurityCode(e.target.value)}
              maxLength={cardFlag == 'amex' ? 4 : 3}
              error={validating && !!securityCodeError}
              errorMessage={securityCodeError}
              icon={<IoIosInformationCircleOutline />}
            />
          </DefaultRowForm>
          <DefaultRowForm>
            <StyledSelect
              isShowOptId={true}
              value={installmentOpt?.value}
              defaultValue={installmentOpt?.value}
              setValue={handleSetInstallments}
              options={installmentsOpts}
              error={validating && !!requiredField(installmentOpt)}
              errorMessage={requiredField(installmentOpt)}
              name="installment"
              placeholder="Parcelas"
              haveMargin={true}
              style={{ width: '96%' }}
            />
            <StyledInput
              haveMargin={true}
              type="text"
              name="holder-email"
              placeholder="E-mail do titular"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              error={validating && !!emailError}
              errorMessage={emailError}
            />
            <StyledInput
              haveMargin={true}
              type="text"
              name="holder-phone"
              placeholder="Telefone titular"
              value={telephone}
              onChange={(e) =>
                setTelephone(formatMobilePhoneNumber(e.target.value))
              }
              maxLength={15}
              error={validating && !!requiredField(telephone)}
              errorMessage={requiredField(telephone)}
            />
          </DefaultRowForm>
          <StyledTitle
            marginTop={3.4}
            title=" Endereço de cobrança do cartão"
          />
          <RowCepForm>
            <StyledInput
              // style={{
              // width: '33.5%'
              // }}
              sizeDisplay="perso"
              haveMargin={true}
              type="text"
              name="cep"
              value={cep}
              placeholder="CEP"
              maxLength={8}
              onChange={(e) => handleCep(e.target.value)}
              error={validating && !!requiredField(cep)}
              errorMessage={requiredField(cep)}
            />
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                marginRight: '3%',
              }}
            >
              <TextCep
                href="https://buscacepinter.correios.com.br/app/endereco/index.php"
                target="_blank"
                rel="noreferrer"
              >
                Não sei meu CEP
              </TextCep>
            </div>
          </RowCepForm>
          <DefaultRowForm>
            <StyledInput
              haveMargin={true}
              type="text"
              name="address"
              placeholder="Endereço"
              value={address}
              onChange={(e) => setAdress(e.target.value)}
              error={validating && !!requiredField(address)}
              errorMessage={requiredField(address)}
            />
            <StyledInput
              haveMargin={true}
              type="text"
              name="number"
              placeholder="Número"
              value={number}
              onChange={(e) => setNumber(e.target.value)}
              error={validating && !!requiredField(number)}
              errorMessage={requiredField(number)}
            />
            <StyledInput
              haveMargin={true}
              type="text"
              name="complement"
              placeholder="Complemento"
              value={adjunct}
              onChange={(e) => setAdjunct(e.target.value)}
            />
          </DefaultRowForm>
          <DefaultRowForm>
            <StyledInput
              haveMargin={true}
              type="text"
              name="neighborhood"
              placeholder="Bairro"
              value={neighborhood}
              onChange={(e) => setNeighborhood(e.target.value)}
              error={validating && !!requiredField(neighborhood)}
              errorMessage={requiredField(neighborhood)}
            />
            <StyledSelect
              value={state?.value}
              defaultValue={state?.value}
              setValue={handleSetState}
              options={Object.keys(UF).map((key) => ({
                id: key,
                value: UF[key as keyof typeof UF],
              }))}
              error={validating && !!requiredField(state)}
              errorMessage={requiredField(state)}
              name="state"
              placeholder="Estado"
              haveMargin={true}
              style={{ width: '96%' }}
            />
            <StyledInput
              haveMargin={true}
              type="text"
              name="city"
              placeholder="Cidade"
              value={city}
              onChange={(e) => setCity(e.target.value)}
              error={validating && !!requiredField(city)}
              errorMessage={requiredField(city)}
            />
          </DefaultRowForm>
        </CreditPaymentDiv>
        <PaymentSummaryContainer>
          <DefaultContainerSummary>
            <TitleSummary>Resumo do pedido:</TitleSummary>
          </DefaultContainerSummary>
          <DefaultContainerSummary marginTop={3}>
            <DefaultTextSummary weight={700} color="#616161">
              {installmentOpt == undefined
                ? ''
                : installmentOpt.id == undefined
                  ? ''
                  : labelToParams(installmentOpt!.id.toString())}
            </DefaultTextSummary>
            <DefaultTextSummary weight={700} color="#F58220">
              &nbsp;
              {installmentOpt == undefined
                ? ''
                : installmentOpt.id == undefined
                  ? ''
                  : labelToValue(installmentOpt!.id.toString())}
            </DefaultTextSummary>
          </DefaultContainerSummary>
          <DefaultContainerSummary marginTop={0.5}>
            <DefaultTextSummary weight={600} color="#424242">
              {new Intl.NumberFormat('pt-BR', {
                currency: 'BRL',
                style: 'currency',
              }).format(Number(installmentOpt?.value))}
            </DefaultTextSummary>
          </DefaultContainerSummary>
          <DefaultContainerSummary marginTop={3}>
            <StyledInput
              type="text"
              name="discont"
              sizeDisplay="md"
              value={cupom}
              onChange={handleCupomInput}
              placeholder="Cupom de desconto"
              icon={<IoIosCheckmarkCircle />}
            />
            <StyledButton
              text={'Aplicar'}
              iconPosition="right"
              icon={<IoIosArrowDroprightCircle />}
              style={{ marginLeft: '16px' }}
            />
          </DefaultContainerSummary>
          <DefaultContainerSummary marginTop={3}>
            <DefaultTextSummary weight={500} color="#1A191A">
              Desconto aplicado
            </DefaultTextSummary>
          </DefaultContainerSummary>
          <DefaultContainerSummary marginTop={0.5}>
            <DefaultTextSummary weight={600} color="#424242">
              {handleMoneyValues(
                -installments.find((i) => i.checked)?.discount! ||
                -pix?.discount! ||
                0,
              )}
            </DefaultTextSummary>
          </DefaultContainerSummary>
          <DefaultContainerSummary marginTop={3} position={'relative'}>
            <LinkLabelSummary onClick={() => setShowModalDetail(true)}>
              Detalhes do pedido
            </LinkLabelSummary>
            <IoIosArrowForward
              style={{
                color: '#F58220',
                position: 'absolute',
                left: '150px',
                top: '3px',
              }}
            />
          </DefaultContainerSummary>
          <DefaultContainerSummary marginTop={3}>
            <Checkbox
              onClick={() => setPrivacyChecked(!privacyChecked)}
            ></Checkbox>
            <DefaultTextSummary weight={400} color="#1A191A">
              Ao informar meus dados, eu concordo com a{' '}
              <DefaultTextLinkSummary onClick={() => setShowPolicyModal(true)}>
                Política de Privacidade
              </DefaultTextLinkSummary>{' '}
              e com os{' '}
              <DefaultTextLinkSummary onClick={() => setShowTermsModal(true)}>
                Termos de Uso
              </DefaultTextLinkSummary>
              ;
            </DefaultTextSummary>
          </DefaultContainerSummary>
          <DefaultContainerSummary marginTop={2}>
            <Checkbox onClick={() => setCpfChecked(!cpfChecked)}></Checkbox>
            <DefaultTextSummary weight={400} color="#1A191A">
              Aceito que meu CPF seja utilizado para a efetivação desse
              pagamento.;
            </DefaultTextSummary>
          </DefaultContainerSummary>
          <DefaultContainerSummary marginTop={4} justifyContent={'center'}>
            <StyledButton
              text={'Confirmar pagamento'}
              type="button"
              iconPosition="right"
              icon={<IoIosArrowDroprightCircle />}
              style={{ marginLeft: '16px' }}
              onClick={() => {
                setShowConfirmModal(true);
              }}
            />
          </DefaultContainerSummary>
          <DefaultContainerSummary
            marginTop={3}
            justifyContent={'center'}
            onClick={() => navigate("/vehicles/details/payments")}
           >
            <IoIosArrowDropleftCircle
              style={{
                color: '#F58220',
                margin: '3px 8px 0 0',
              }}
            />
            <LinkLabelSummary>Voltar</LinkLabelSummary>
          </DefaultContainerSummary>
          <DefaultContainerSummary
            marginTop={7.11}
            style={{
              position: 'absolute',
              bottom: 0,
              width: '100%',
              left: 0,
              background: '#F58220',
              minHeight: '183px',
              padding: '24px 75px 20px 75px',
              flexDirection: 'column',
              // height: '100%'
            }}
          >
            <div style={{ maxWidth: '100%' }}>
              <Link
                target="_blank"
                rel="noopener noreferrer"
                href="https://www.in.gov.br/en/web/dou/-/portaria-senatran-n-479-de-29-de-maio-de-2023-496686482"
              >
                <img
                  style={{ width: '100%' }}
                  src={'/logos/logo-gov-brasil-transport.png'}
                  alt="Ministério da Infraestrutura"
                />
              </Link>
            </div>
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-evenly',
                alignItems: 'center',
              }}
            >
              <div style={{ maxWidth: '100%' }}>
                <Link
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://zignet-storage-public.s3.us-east-2.amazonaws.com/docs/PCI-2021.pdf"
                >
                  <img
                    style={{ width: '100%' }}
                    src={'/logos/pci-logo.png'}
                    alt="Ministério da Infraestrutura"
                  />
                </Link>
              </div>
              <div style={{ maxWidth: '100%' }}>
                <Link
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://zignet-storage-public.s3.us-east-2.amazonaws.com/docs/certificacao-cerc.pdf"
                >
                  <img
                    style={{ width: '100%' }}
                    src={'/logos/cerc-branco.png'}
                    alt="Ministério da Infraestrutura"
                  />
                </Link>
              </div>
            </div>
          </DefaultContainerSummary>
        </PaymentSummaryContainer>
      </DefaultContainer>
    </>
  );
};

export default CreditPayment;
